import React from 'react';
import S from './Select.styles';
const Select = React.forwardRef(({ children, className, readOnly = false, multiple = false, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { className: className },
        React.createElement(S.Select, { ref: ref, ...otherProps, disabled: readOnly, multiple: multiple }, children)));
});
Select.displayName = 'Select';
export default Select;
